//#region src/errors/util/check-field-errors.ts
var e = (t) => typeof t != "object" || Array.isArray(t) || t === null ? (console.error("field has wrong type"), !1) : Object.values(t).some((t) => Array.isArray(t) ? t.length : e(t));
//#endregion
export { e as checkAreThereFieldsErrors };
